import { render, staticRenderFns } from "./PinballGame.vue?vue&type=template&id=45607f1d&"
import script from "./PinballGame.vue?vue&type=script&lang=js&"
export * from "./PinballGame.vue?vue&type=script&lang=js&"
import style0 from "./PinballGame.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports